<template>
  <div class="hvh-flex align-center" :title="limitLeafMessage">
    <div class="vue-treeselect__icon-container"><span class="vue-treeselect__icon-warning"></span></div>
    <div class="limit-leaf no-wrap pl-1">{{ limitLeafMessage }}</div>
  </div>
</template>

<script>
export default {
  noExport: true,
  data() {
    return {
      limitLeafMessage: 'Results limited to 100 - Refine search query to see more',
    };
  },
}
</script>

<style lang="scss" scoped>
.limit-leaf {
  color: red;
}
</style>